var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=InfoTooltip, colour=Secondary, htmlTag=img, assetKey=Content, state=Default"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 12.8295,
    cy: 12,
    r: 10,
    fill: "#E6F1F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info",
    d: "M11.8295 17H13.8295V11H11.8295V17ZM12.8295 9C13.1129 9 13.3504 8.90417 13.542 8.7125C13.7337 8.52083 13.8295 8.28333 13.8295 8C13.8295 7.71667 13.7337 7.47917 13.542 7.2875C13.3504 7.09583 13.1129 7 12.8295 7C12.5462 7 12.3087 7.09583 12.117 7.2875C11.9254 7.47917 11.8295 7.71667 11.8295 8C11.8295 8.28333 11.9254 8.52083 12.117 8.7125C12.3087 8.90417 12.5462 9 12.8295 9Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTooltip);
export default __webpack_public_path__ + "static/media/InfoTooltip.81a2e25d6edd1377b820a43426253428.svg";
export { ForwardRef as ReactComponent };